export default __webpack_public_path__ + "static/media/arrow-button.ab273561.svg";